import { render } from "./FooterBlock.vue?vue&type=template&id=05d63547&scoped=true"
import script from "./FooterBlock.vue?vue&type=script&lang=js"
export * from "./FooterBlock.vue?vue&type=script&lang=js"

import "./FooterBlock.vue?vue&type=style&index=0&id=05d63547&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/freelance/naks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d63547"]])

export default __exports__